import React, {useContext} from 'react';
import GoodItem from "./GoodItem";
import {GlobalContext} from "../context/GlobalProvider";

const Goods = () => {

    const {
        state: {goods},
        dispatch,
    } = useContext(GlobalContext);

    const addGoodItem = () => {
        dispatch({
            type: "ADD_GOOD"
        })
    }

    return (
        <>
            {goods.map((item, index) => {
                return <GoodItem index={index}/>
            })}
            <button
                type="button"
                className="btn--black border border-white gap-[10px]"
                onClick={addGoodItem}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                    <path d="M1 5H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    <path d="M5 1V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                Weiteres Produkt hinzufügen
            </button>
        </>
    );
};

export default Goods;
